import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/**
 * Removes hashtags from text for display purposes
 * Hashtags are kept in the database but hidden from users
 */
export function stripHashtags(text: string): string {
    return text.replace(/#\w+/g, '').replace(/\s+/g, ' ').trim()
}

/**
 * Normalizes image URLs, specifically fixing YouTube thumbnails
 * that often have black bars at the top and bottom.
 */
export function getCleanImageUrl(url: string | null | undefined): string {
    if (!url) return "";
    // YouTube specific: hqdefault.jpg often has black bars (it's 4:3).
    // mqdefault.jpg is 16:9 and fills better.
    if (url.includes('i.ytimg.com/vi/') && url.includes('hqdefault.jpg')) {
        return url.replace('hqdefault.jpg', 'mqdefault.jpg');
    }
    return url;
}

export const CURRENT_LEGAL_VERSION = "2.0";
export const ENABLE_BETA_POPUP = false;

/**
 * Returns the appropriate app store link based on the user's OS
 */
export function getStoreLink(): string {
    const ua = navigator.userAgent || ""
    if (/iPhone|iPad|iPod/i.test(ua)) return "https://apps.apple.com/app/id6781581447"
    if (/Android/i.test(ua)) return "https://play.google.com/store/apps/details?id=com.shuvo.app"
    return "https://shuvo.pro" // Fallback to landing page for desktop
}
